<template>
    <div class="router-watch">
        <div>好きなパラメーターを入力：<input v-model="inputParams" type="text"></div>
        <button @click="changeParams">パラメーターを変更してwacthの動きを見る</button>

        <p>画面遷移前パラメータ：{{this.beforeRouter}}</p>
        <p>画面遷移後パラメータ：{{this.afterRouter}}</p>

        <div v-if="err" style="color:red;">{{this.err}}</div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            beforeRouter: '',
            afterRouter: '',
            inputParams: null,
            err: null 
        }
    },
    watch:{
        '$route'(to, from) {
            this.beforeRouter = from.params.id
            this.afterRouter = to.params.id
        }
    },
    methods:{
        changeParams(){
            if(this.inputParams){
                //routerのnameは"router-watch"、routerのpathは"/router-watch/:id"に設定しています
                this.$router.push({ name: 'router-watch', params:{id: this.inputParams} });
                this.err = null
                this.inputParams = null
            }else{
                this.err = "パラメーターを入力してね"
            }
        }
    }
}
</script>

<style scoped>

</style>